export default __webpack_public_path__ + "static/media/jett.5039d720.png";